.root {
  &.left {
    justify-content: flex-start;
  }

  &.right {
    justify-content: flex-end;
  }

  &.spread {
    justify-content: space-between;
  }

  &.withDivider {
    border-top: solid 1px var(--theme--color--grey--light);
  }

  & {
    padding: var(--theme--tokens--card--padding);
    padding-top: calc(var(--theme--tokens--card--padding) / 2);
  }
}
